import React from "react";
import { useParams } from "react-router-dom";
import ViewPage from "../../components/view/ViewPage";
import ViewTextField from "../../components/view/fields/ViewTextField";
import ViewFieldCard from "../../components/view/fields/ViewFieldCard";
import ViewRichTextField from "../../components/view/fields/ViewRichTextField";
import useBibliographyController from "../../controllers/bibliographyController";
import { Bibliography } from "../../types/bibliography";

const ViewBibliographyPage: React.FC = () => {
  const { _id } = useParams<{ _id: string }>();

  if (!_id) {
    throw new Error("Bibliography ID is required for viewing.");
  }

  const controller = useBibliographyController(_id);

  return (
    <ViewPage<Bibliography> controller={controller}>
      <ViewFieldCard title="Basic Information">
        <ViewTextField name="published_id" label="Intellexus ID" />
        <ViewTextField name="filename" label="Filename" />
        <ViewTextField name="author" label="Author" />
        <ViewTextField name="title" label="Title" />
        <ViewTextField name="year" label="Year" />
        <ViewTextField name="volumes" label="Volumes" />
      </ViewFieldCard>

      <ViewFieldCard title="Sanskrit References">
        <ViewTextField name="sanskritof" label="Sanskrit Of" />
        <ViewTextField name="sans_complete" label="Sanskrit Complete" />
        <ViewTextField name="sans_tohoku" label="Sanskrit Tohoku" />
        <ViewTextField name="sans_otani" label="Sanskrit Otani" />
      </ViewFieldCard>

      <ViewFieldCard title="Tibetan References">
        <ViewTextField name="tibetanof" label="Tibetan Of" />
        <ViewTextField name="tibe_complete" label="Tibetan Complete" />
        <ViewTextField name="tibe_tohoku" label="Tibetan Tohoku" />
        <ViewTextField name="tibe_otani" label="Tibetan Otani" />
      </ViewFieldCard>

      <ViewFieldCard title="Publication Details">
        <ViewTextField name="journal" label="Journal" />
        <ViewTextField name="booktitle" label="Book Title" />
        <ViewTextField name="bookeditor" label="Book Editor" />
        <ViewTextField name="publisher" label="Publisher" />
        <ViewTextField name="publicationplace" label="Publication Place" />
        <ViewTextField name="startpage" label="Start Page" />
        <ViewTextField name="endpage" label="End Page" />
      </ViewFieldCard>

      <ViewFieldCard title="Series Information">
        <ViewTextField name="seriesname" label="Series Name" />
        <ViewTextField name="seriesnumber" label="Series Number" />
        <ViewTextField name="serieseditor" label="Series Editor" />
      </ViewFieldCard>

      <ViewFieldCard title="Notes">
        <ViewRichTextField name="notes" />
      </ViewFieldCard>

      <ViewFieldCard title="Additional Information">
        <ViewTextField name="source" label="Source" />
        <ViewTextField name="jababo" label="JABABO" />
        <ViewTextField name="no_of_volumes" label="Number of Volumes" />
        <ViewTextField name="volume_no" label="Volume Number" />
        <ViewTextField name="ardi_id" label="ARDI ID" />
        <ViewTextField name="owner" label="Owner" />
      </ViewFieldCard>
    </ViewPage>
  );
};

export default ViewBibliographyPage;

